var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicadorB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1280,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculadoraV3-comocalcular",
    transform: "translate(-354.000000, -406.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30-Copy",
    transform: "translate(324.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy",
    transform: "translate(30.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    fill: "#508221",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("text", {
    id: "B",
    fontFamily: "Lato-Bold, Lato",
    fontSize: 12,
    fontWeight: "bold",
    "line-spacing": 17,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.091,
    y: 13
  }, "B"))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicadorB);
export default __webpack_public_path__ + "static/media/indicador-B.0f541344.svg";
export { ForwardRef as ReactComponent };